import commonSlice from '../common';
import { illustrationSlice } from './illustration';
import { textWithIllustrationSlice } from './text-with-illustration';

const PRISMIC_TO_PARSER_SLICE = {
  ...commonSlice,
  illustration: illustrationSlice,
  text_with_illustration: textWithIllustrationSlice,
};

export default PRISMIC_TO_PARSER_SLICE;
